export function formatCuotasPlan(cuotas_plan) {
  try {
    //{\"anio\": 2008, \"cuota\": 1, \"recurso\": \"AB\", \"imponible\": 8000854185}

    if (cuotas_plan) {
      let array = JSON.parse(cuotas_plan);

      return array.reduce((prevArray, currentObject) => {
        if (prevArray?.length) {
          let same = prevArray.some(e => e.imponible === currentObject.imponible && e.recurso === currentObject.recurso);

          if (same) {
            let result = prevArray.map(element => {
              if (element.imponible === currentObject.imponible && element.recurso === currentObject.recurso) {
                let sameAnio = element.deudas.some(e => e.anio === currentObject.anio);
                if (sameAnio) {
                  let newDeudas = element.deudas.map(d => {
                    if (d.anio === currentObject.anio) {
                      return {
                        ...d,
                        cuotas: [...d.cuotas, currentObject.cuota]
                      };
                    }
                    else {
                      return d;
                    }
                  });

                  return {
                    ...element,
                    deudas: newDeudas,
                  };
                }
                else {
                  return {
                    ...element,
                    deudas: [
                      ...element.deudas,
                      {
                        anio: currentObject.anio,
                        cuotas: [currentObject.cuota]
                      }
                    ]
                  };
                }
              }
              else {
                return element;
              }
            });

            return result;
          }
          else {
            return [
              ...prevArray,
              {
                imponible: currentObject.imponible,
                recurso: currentObject.recurso,
                deudas: [
                  {
                    anio: currentObject.anio,
                    cuotas: [currentObject.cuota]
                  }
                ]
              }
            ];
          }
        }
        else {
          return [
            {
              imponible: currentObject.imponible,
              recurso: currentObject.recurso,
              deudas: [
                {
                  anio: currentObject.anio,
                  cuotas: [currentObject.cuota]
                }
              ]
            }
          ];
        }
      }, []);
    }
  }
  catch (err) {
    console.log("error", err);
  }
}